import { IHttpService, IPromise } from 'angular';
import { ISelectedItem } from '../../../shared/components/gmc-select/interfaces';
import { GmcApi } from '../../constants/gmc-api';

export interface ILanguageResponse {
  result: string[];
}

export class LanguageService {
  static $inject = [
    '$http',
    'GmcApi'
  ];
  languageLevels: string[] = [
    'No knowledge',
    'Elementary',
    'Low intermediate',
    'High intermediate',
    'Advanced',
    'Proficient',
    'Native'
  ];
  private languages: string[];

  constructor( private $http: IHttpService,
               private gmcApi: GmcApi ) {
  }

  getLanguages(): IPromise<string[]> {
    return this.$http.get<ILanguageResponse>(this.gmcApi.helpers.getAllLanguages, { cache: true })
      .then(( res ) => {
        this.languages = res.data.result;
        return this.languages;
      });
  }
}



// WEBPACK FOOTER //
// ./app/core/services/language/language.service.ts